import { ReactNode, useEffect, useRef, useState } from "react";

import { Tooltip, Typography, TypographyVariant } from "@mui/material";

interface Props {
  value: string | null | undefined;
  variant: TypographyVariant;
  fontWeight?: string | number;
  color?: string;
  children?: ReactNode;
}

export const EllipsisText = ({ value, variant, fontWeight, color, children }: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  const checkTruncate = () => {
    const el = ref.current;
    if (!el) {
      return;
    }

    setIsTruncated(el.scrollWidth > el.clientWidth);
  };

  useEffect(() => {
    const el = ref.current;
    if (!el) {
      return;
    }

    checkTruncate();

    window.addEventListener("resize", checkTruncate);

    return () => {
      window.removeEventListener("resize", checkTruncate);
    };
  }, [value]);

  const displayValue = value ?? "";

  const typographyContent = (
    <div
      ref={ref}
      style={{
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        width: "100%",
      }}
    >
      <Typography variant={variant} component={"span"} fontWeight={fontWeight} color={color}>
        {children ?? displayValue}
      </Typography>
    </div>
  );

  return isTruncated ? (
    <Tooltip title={displayValue} arrow>
      {typographyContent}
    </Tooltip>
  ) : (
    typographyContent
  );
};
